import React from "react";
import Particles from "react-tsparticles"
import { loadFull } from "tsparticles";
import { useCallback } from "react";


const ParticlesBackground = ({isDarkMode}) => {
    const particlesInit = useCallback(async engine => {
        // console.log(engine);
        // you can initiate the tsParticles instance (engine) here, adding custom shapes or presets
        // this loads the tsparticles package bundle, it's the easiest method for getting everything ready
        // starting from v2 you can add only the features you need reducing the bundle size
        await loadFull(engine);
    }, []);

	const particlesLoaded = useCallback(async container => {
        // await console.log(container);
    }, []);


    return(
        <Particles
            id="tsparticles"
            init={particlesInit}
            loaded={particlesLoaded}
            options={{
                background: {
                    color: {
                      value: `${isDarkMode ? '#000' : '#ffffff' }`
                    },
                    image: "",
                    position: "",
                    repeat: "",
                    size: "",
                    opacity: 1
                  },
                  fullScreen: {
                    enable: true,
                    zIndex: -1
                  }, 
                fpsLimit: 120,
                interactivity: {
                    events: {
                        onClick: {
                            enable: false,
                            mode: "push",
                        },
                        onHover: {
                            enable: false,
                            mode: "repulse",
                        },
                        resize: false,
                    },
                    modes: {
                        push: {
                            quantity: 4,
                        },
                        repulse: {
                            distance: 200,
                            duration: 0.4,
                        },
                    },
                },
                particles: {
                    color: {
                        value: `${isDarkMode ? '#ffffff' : '#000' }`,
                    },
                    links: {
                        color: `${isDarkMode ? '#ffffff' : '#000' }`,
                        distance: 150,
                        enable: true,
                        opacity: 0.5,
                        width: 1,
                    },
                    move: {
                        direction: "none",
                        enable: true,
                        outModes: {
                            default: "bounce",
                        },
                        random: false,
                        speed: 2,
                        straight: false,
                    },
                    number: {
                        density: {
                            enable: true,
                            area: 1000,
                        },
                        value: 150,
                    },
                    opacity: {
                        value: 0.4,
                    },
                    shape: {
                        close: true,
                        fill: true,
                        type: "circle",
                    },
                    size: {
                        value: { min: 1, max: 5 },
                    },
                },
                detectRetina: true,
            }}
        />
    )
}

export default ParticlesBackground